import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PersonalizationService {

  onThemeChanged: EventEmitter<String> = new EventEmitter<String>();

  constructor() { }


  SetTheme(isLight = true) {
    if (isLight) {
      localStorage.setItem("theme", "light");
      this.onThemeChanged.emit("light");
    } else {
      localStorage.setItem("theme", "dark");
      this.onThemeChanged.emit("dark");
    }
  }

  IsThemeSet() {
    return localStorage.getItem("theme") != null;
  }

  GetTheme() {
    return localStorage.getItem("theme");
  }

}
